import { css } from '@/styled-system/css';

export const calendarControlsStyles = css.raw({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 'tightest',
  paddingInline: 'tightest',
  textStyle: 'body-bold',
});
